import React from "react";
import { Stack } from "@mui/material";
import { cardStyles as styles } from "layouts/pages/customers/styles";
import {
  AwardsSection,
  CertificationsSection,
  ContactSection,
  EducationSection,
  ExperienceSection,
  LanguagesSection,
  LicensesSection,
  ObjectiveSection,
  PortfolioSection,
  ReferencesSection,
  SkillsSection,
  WorkHistorySection,
} from "./components/Sections";

export const ResumeContent = ({ resumeData, height = 750 }) => {
    if (!resumeData) return null;

    return (
    <Stack sx={{ ...styles.container, height, mt: 2 }} spacing={3}>
      <ContactSection contactInfo={resumeData.contactInfo} />
      <ObjectiveSection objective={resumeData.objective} jobTitle={resumeData.jobTitle} />
      <ExperienceSection
        overallExperience={resumeData.overallExperience}
        industries={resumeData.industries}
      />
      <WorkHistorySection jobHistory={resumeData.jobHistory} />
      <EducationSection education={resumeData.education} />
      <SkillsSection skillsData={resumeData.skillsData} />
      <LanguagesSection languages={resumeData.languages} />
      <CertificationsSection certifications={resumeData.certifications} />
      <LicensesSection licenses={resumeData.licenses} />
      <PortfolioSection portfolio={resumeData.portfolio} />
      <AwardsSection awards={resumeData.awards} />
      <ReferencesSection references={resumeData.references} />
    </Stack>
    );
};

export default ResumeContent;

